import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";

interface TrashIconButtonProps {
    onClick: () => void;
    ariaLabel: string;
}

const TrashIconButton = (props: TrashIconButtonProps) => {
    return (
        <button
            type="button"
            onClick={props.onClick}
            aria-label={props.ariaLabel}
            className="flex items-center justify-center min-w-[44px] min-h-[44px] cursor-pointer"
        >
            <PhaseSixIcon name="trash" className="text-[30px] text-p6-grey-dark" />
        </button>
    );
};

export default TrashIconButton;
